module.exports = __webpack_public_path__ + "assets/img/thumb-Aussie-Broadband-eBook.906b93cb.png";